import type { RecordRow } from '../../../data/client';
import { useRecord } from '../../../data/hooks';
import { Skeleton } from '../../../ui';
import { recordTitle } from '../../records/table/tableModel';

/**
 * One searchable result, resolved from the CANONICAL cache entry the search query
 * already seeded (INV-13) - so the list renders without a request per row, and the
 * record it names is the same object every other surface in the app is holding.
 *
 * Its own component because a row that reads a record needs a hook, and the picker
 * renders a dynamic number of them.
 */
export interface PickerOptionProps {
  readonly objectId: string;
  readonly recordId: string;
  readonly labelFieldId: string;
  readonly disabled: boolean;
  readonly onPick: (row: RecordRow) => void;
}

export function PickerOption({
  objectId,
  recordId,
  labelFieldId,
  disabled,
  onPick,
}: PickerOptionProps) {
  const record = useRecord(objectId, recordId);
  const row = record.data;

  if (row === undefined || row === null) {
    return (
      <li className="flex min-h-11 items-center">
        <Skeleton className="h-4 w-40" />
      </li>
    );
  }

  return (
    <li>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onPick(row)}
        className="flex min-h-11 w-full items-center rounded-control px-2 text-left text-base text-ink hover:bg-surface-hover disabled:opacity-50"
      >
        {recordTitle(row, labelFieldId)}
      </button>
    </li>
  );
}
